module.exports = __webpack_public_path__ + "img/university.3d39533d.png";